var path = '/templates/core/views/tos.html';
var html = "<div class=document-wrapper><div class=row><div class=\"col-md-push-2 col-md-8\"><div ng-switch=vm.selectedLanguage.id class=document-wrapper><ng-container ng-switch-when=zh><zc-terms-of-service-appier-inc></zc-terms-of-service-appier-inc></ng-container><ng-container ng-switch-when=ja><zc-terms-of-service-appier-jp></zc-terms-of-service-appier-jp></ng-container><ng-container ng-switch-default><zc-terms-of-service-appier-others></zc-terms-of-service-appier-others></ng-container></div><zc-data-processing-addendum></zc-data-processing-addendum></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/tos.html
// module id = 1331
// module chunks = 0